import { render, staticRenderFns } from "./ComponentPendenciaBase.vue?vue&type=template&id=ec974f54&scoped=true"
import script from "./ComponentPendenciaBase.vue?vue&type=script&lang=ts"
export * from "./ComponentPendenciaBase.vue?vue&type=script&lang=ts"
import style0 from "./ComponentPendenciaBase.vue?vue&type=style&index=0&id=ec974f54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec974f54",
  null
  
)

export default component.exports